// Pagina "Scegli il tuo locker" (sections/main-locker.liquid): precompila ordine ed email dai parametri
// ?ordine= e ?email= del link nell'email di conferma, blocca l'invio senza locker e compone il messaggio.
(function () {
  var form = document.getElementById('LockerForm');
  if (!form) return;
  var params = new URLSearchParams(location.search);
  form.querySelectorAll('[data-param]').forEach(function (i) {
    var v = params.get(i.dataset.param);
    if (v && !i.value) i.value = v;
  });
  // Toglie ordine ed email dalla barra degli indirizzi (cronologia, segnalibri, condivisioni)
  if (params.has('ordine') || params.has('email')) history.replaceState(null, '', location.pathname);
  var err = form.querySelector('[data-locker-err]');
  form.addEventListener('locker:chosen', function () { err.hidden = true; });
  form.addEventListener('submit', function (e) {
    var code = form.querySelector('[data-code]').value;
    if (!code) {
      e.preventDefault();
      err.hidden = false;
      err.scrollIntoView({ block: 'center' });
      return;
    }
    form.querySelector('[data-body]').value = 'Ordine ' + form.querySelector('#LockerOrder').value + ' → locker InPost ' +
      code + ' – ' + form.querySelector('[data-addr]').value;
  });
})();
